export type InputSize = 'extrasmall' | 'small' | 'medium' | 'large';

export const InputSizeMap: Record<InputSize, number> = {
  extrasmall: 25,
  small: 50,
  medium: 75,
  large: 200,
};

/**
 1cm = +- 11.25 dots
 xs = 1cm, s = 5cm, m=8cm, l=12cm
 */

export const InputSizeToDotsMap: Record<InputSize, number> = {
  extrasmall: 11,
  small: 56,
  medium: 90,
  large: 135,
};

export const InputDotsUnbreakable = 56;

export const InputDotsFullWidth = 500;

export const InputDotsFullWidthMinInlineSizePixels = 320;
